"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountUrl = void 0;
/**
 * Método responsável por substituir path params em uma url
 * @param path url com path params para serem substituídos (padrão do param é $param)
 * @param params Objeto com os valores a serem substituídos, cada key representa um pathParam
 */
function mountUrl(path = '', params = {}) {
    return Object.keys(params).reduce((acc, it) => acc.replace(`$${it}`, params[it]), path);
}
exports.mountUrl = mountUrl;
